export const ROUTES = {
  dashboard: "/dashboard",
  units: "/units",
  unitDetail: "/units/:id",
  patients: "/airmen",
  patientDetail: "/airmen/:id",
  heartRateDetail: "/airmen/:id/heart-rate",
  bodyWeightDetail: "/airmen/:id/body-weight",
  bloodOxygenSaturationDetail: "/airmen/:id/blood-oxygen-saturation",
  bodyTemperatureDetail: "/airmen/:id/body-temperature",
  stepsDetail: "/airmen/:id/steps",
  bloodGlucoseDetail: "/airmen/:id/blood-glucose",
  bloodPressureDetail: "/airmen/:id/blood-pressure",
  insoles: "/insoles",
  login: "/login",
  regularAdmins: "/regular-admins",
  fileManager: "/file-manager",
  firmwares: "/firmwares",
  firmwaresDetail: "/firmwares/:id",
} as const;

export const MODAL_ROUTES = {
  successModal: "/successModal",
} as const;
